import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ClipboardList, FileSignature, BookOpen, Vote, CalendarDays } from "lucide-react";
import { useAuth } from "../../hooks/useAuth";
import { useLocalization } from "../../hooks/useLocalization";
import { onboardingApi } from "../../services/onboardingApi";
import { OnboardingProgress } from "../../components/OnboardingProgress";
import { StatusBadge } from "../../components/StatusBadge";
import { PageHelpBanner } from "../../components/PageHelpBanner";

export default function EmployeeHomePage() {
  const { user } = useAuth();
  const { t } = useLocalization();
  const [onboardingCase, setOnboardingCase] = useState(null);

  useEffect(() => {
    if (user?.employee_id) {
      onboardingApi.getCaseByEmployee(user.employee_id).then((r) => setOnboardingCase(r.data)).catch(() => {});
    }
  }, [user]);

  return (
    <div data-testid="employee-home-page" className="space-y-6">
      <PageHelpBanner pageKey="employee-home" title={t("pageHelp.defaultTitle")}>
        <p>{t("pageHelp.employeeHome")}</p>
      </PageHelpBanner>
      <div className="flex items-center gap-3">
        <img src="/yokolicious-eagle-salute.png" alt="" className="h-14 w-14 object-contain" data-testid="home-mascot" />
        <div>
          <h2 className="text-2xl font-bold tracking-tight text-gray-900">{t("auth.welcomeBack")}, {user?.name}</h2>
          <p className="text-sm text-gray-500">{t("portal.staffPortal")}</p>
        </div>
      </div>

      {onboardingCase && (
        <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm" data-testid="home-onboarding-summary">
          <div className="flex items-center justify-between mb-3">
            <p className="text-sm font-semibold text-gray-800">{t("nav.myOnboarding")}</p>
            <StatusBadge status={onboardingCase.status} />
          </div>
          <OnboardingProgress requirements={onboardingCase.requirements} />
        </div>
      )}

      <div className="grid grid-cols-1 gap-3">
        <Link to="/employee/schedule" data-testid="quick-link-schedule" className="flex items-center gap-3 bg-white rounded-xl border border-gray-200 p-4 hover:shadow-md transition-shadow">
          <CalendarDays className="text-blue-600" size={20} /> <span className="text-sm font-medium text-gray-700">{t("nav.mySchedule")}</span>
        </Link>
        <Link to="/employee/onboarding" data-testid="quick-link-onboarding" className="flex items-center gap-3 bg-white rounded-xl border border-gray-200 p-4 hover:shadow-md transition-shadow">
          <ClipboardList className="text-blue-600" size={20} /> <span className="text-sm font-medium text-gray-700">{t("nav.myOnboarding")}</span>
        </Link>
        <Link to="/employee/contract" data-testid="quick-link-contract" className="flex items-center gap-3 bg-white rounded-xl border border-gray-200 p-4 hover:shadow-md transition-shadow">
          <FileSignature className="text-blue-600" size={20} /> <span className="text-sm font-medium text-gray-700">{t("nav.myContract")}</span>
        </Link>
        <Link to="/employee/policies" data-testid="quick-link-policies" className="flex items-center gap-3 bg-white rounded-xl border border-gray-200 p-4 hover:shadow-md transition-shadow">
          <BookOpen className="text-blue-600" size={20} /> <span className="text-sm font-medium text-gray-700">{t("nav.myPolicies")}</span>
        </Link>
        <Link to="/employee/article36-vote" data-testid="quick-link-article36-vote" className="flex items-center gap-3 bg-white rounded-xl border border-gray-200 p-4 hover:shadow-md transition-shadow">
          <Vote className="text-blue-600" size={20} /> <span className="text-sm font-medium text-gray-700">{t("nav.myArticle36Vote")}</span>
        </Link>
      </div>
    </div>
  );
}
